import api from './index';
//
let exports = {};

exports.getDevcMaintCheckItemPageList = function (data, callback) {// 设备维护保养检查项分页列表
    api.post('/devc/maint/check/item/page/list/get')
    .data(data)
    .done(callback)
    .go();
};

exports.getDevcMaintCheckItemList = function (data, callback) {// 设备维护保养检查项分页列表
    api.post('/devc/maint/check/item/list/get')
    .data(data)
    .done(callback)
    .go();
};

exports.getDevcMaintCheckItemById = function (params, callback) {// 设备维护保养检查项
    api.get('/devc/maint/check/item/get/by/id')
    .params(params)
    .done(callback)
    .go();
};

exports.doSaveDevcMaintCheckItem = function (data, callback) {// 保存设备维护保养检查项
    api.post('/devc/maint/check/item/save/do')
    .data(data)
    .done(callback)
    .go();
};

exports.doDeleteDevcMaintCheckItem = function (data, callback) {// 删除设备维护保养检查项
    api.post('/devc/maint/check/item/delete/do')
    .data(data)
    .done(callback)
    .go();
};

exports.moveUpOrDownDevcMaintCheckItem = function (data, callback) {// 上下移动设备维护保养检查项
    api.post('/devc/maint/seq/move/do')
    .data(data)
    .done(callback)
    .go();
};

exports.doDisabledDownDevcMaintCheckItem = function (data, callback) {// 禁用设备维护保养检查项
    api.post('/devc/maint/check/item/disabled/do')
    .data(data)
    .done(callback)
    .go();
};

exports.doCopyDevcMaintCheckItem = function (data, callback) {// 禁用设备维护保养检查项
    api.post('/devc/maint/check/item/copy/do')
    .data(data)
    .done(callback)
    .go();
};

// -------------------------------------- 凭单 --------------------------------------

// 获取pdf模板信息
exports.getDevcMaintPdfTpl = function (data, callback) {
    api.get('/devc/maint/proof/pdfTpl/get')
    .data(data)
    .done(callback)
    .go();
};

// 凭单列表
exports.getDevcMaintProofList = function (data, callback) {
    api.post('/devc/maint/proof/list/get')
    .data(data)
    .done(callback)
    .go();
};

// 凭单详情（包含子项）
exports.getDevcMaintProofInfo = function (params, callback) {
    api.get('/devc/maint/proof/info/get')
    .params(params)
    .done(callback)
    .go();
};
// 启、禁用
exports.updateDevcMaintProofForDisabled = function (data, callback) {
    api.post('/devc/maint/proof/disabled/update/do')
    .data(data)
    .done(callback)
    .go();
};
// 保存
exports.saveDevcMaintProofInfo = function (data, callback) {
    api.post('/devc/maint/proof/save/do')
    .data(data)
    .done(callback)
    .go();
};
// 凭单-检查项-排序
exports.moveUpOrDownDevcMaintProofCheckItem = function (data, callback) {
    api.post('/devc/maint/proof/checkItem/seq/move/do')
    .data(data)
    .done(callback)
    .go();
};
// 删除
exports.deleteDevcMaintProof = function (data, callback) {
    api.post('/devc/maint/proof/delete/do')
    .data(data)
    .done(callback)
    .go();
};
//
exports.getUnivCheckCombInfo = function (params, callback) {
    api.get('/devc/univ/check/comb/info/get')
    .params(params)
    .done(callback)
    .go();
};
exports.getUnivCheckCombList = function (data, callback) {
    api.post('/devc/univ/check/comb/page/list/get')
    .data(data)
    .done(callback)
    .go();
};
exports.getUnivCheckCombInners = function (data, callback) {
    api.post('/devc/univ/check/comb/inner/list/get')
    .data(data)
    .done(callback)
    .go();
};
exports.getUnivCheckCombExternals = function (data, callback) {
    api.post('/devc/univ/check/comb/external/list/get')
    .data(data)
    .done(callback)
    .go();
};
exports.saveUnivCheckComb = function (data, callback) {
    api.post('/devc/univ/check/comb/save/do')
    .data(data)
    .done(callback)
    .go();
};
exports.saveUnivCheckCombForBatch = function (data, callback) {
    api.post('/devc/univ/check/comb/copy/batch/do')
    .data(data)
    .done(callback)
    .go();
};
exports.updateUnivCheckComb = function (data, callback) {
    api.post('/devc/univ/check/comb/update/do')
    .data(data)
    .done(callback)
    .go();
};
exports.updateUnivCheckCombForDisabled = function (data, callback) {
    api.post('/devc/univ/check/comb/disabled/update/do')
    .data(data)
    .done(callback)
    .go();
};
exports.deleteUnivCheckComb = function (data, callback) {
    api.post('/devc/univ/check/comb/delete/do')
    .data(data)
    .done(callback)
    .go();
};
exports.deleteUnivCheckCombForBatch = function (data, callback) {
    api.post('/devc/univ/check/comb/delete/for/batch/do')
    .data(data)
    .done(callback)
    .go();
};
exports.getDevcMaintProofListByFilter = function (data, callback) {
    api.post('/devc/maint/proof/list/get/by/filter')
        .data(data)
        .done(callback)
        .go();
};
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/devcMaint.js
// module id = 83
// module chunks = 0